import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, inject, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { BottomNavComponent } from "@app/core/navigation/bottom-nav/bottom-nav.component";
import { TopNavComponent } from "@app/core/navigation/top-nav/top-nav.component";
import { SwapRequestService } from "@app/shared/swap-request/services/swap-request.service";
import { TranslatePipe } from "@ngx-translate/core";
import { filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-dashboard-layout",
  templateUrl: "./dashboard-layout.component.html",
  styleUrls: ["./dashboard-layout.component.scss"],
  imports: [CommonModule, RouterModule, FormsModule, TopNavComponent, BottomNavComponent, TranslatePipe],
})
export class DashboardLayoutComponent implements AfterViewInit {
  @ViewChild("content") scrollContainer!: ElementRef<HTMLDivElement>;
  warningBannerClosed = false;

  swapRequestService = inject(SwapRequestService);
  private readonly route = inject(ActivatedRoute);
  private readonly fragment$ = this.route.fragment.pipe(filter(Boolean), takeUntilDestroyed());

  closeWarningBanner() {
    this.warningBannerClosed = true;
  }

  ngAfterViewInit() {
    this.fragment$.subscribe(fragment => this.scrollToFragment(fragment!));
  }

  private scrollToFragment(id: string): void {
    const container = this.scrollContainer.nativeElement as HTMLElement;
    const target = container.querySelector<HTMLElement>(`#${CSS.escape(id)}`);
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
